import { Dispatch } from "react";
import jwtAxios from "../../utils/jwtAxios";
import { AppActions } from "../../types/AppActions";
import { fetchError } from "./Common";
import { SubscriptionConfig } from "../../types/models/SubscriptionConfig";
import { UserData } from "../../types/models/UserData";

export interface SubscriptionData {
  current_tier: string | null;
  stripe_id: string;
  renewal_date: Date | null;
  interval: string;
  name: string;
  status: string;
  amount: string;
  cancel_at_period_end: boolean;
}

export const checkLimit = (group_id: string, callBack: (SubscriptionConfig?: SubscriptionConfig | null) => void) => {
  var subscriptionConfig: SubscriptionConfig | null = null;
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get('/api/subscription/limits?groupId=' + group_id) 
      .then((data) => {
        if (data.status === 200) {
            subscriptionConfig = data.data;
          callBack(subscriptionConfig);
        } else {
          dispatch(fetchError("Request failed. Status: " + data.status));
          callBack(subscriptionConfig);
        }
      })
      .catch((error) => {
        dispatch(fetchError(
          error.response.data.detail
            ? error.response.data.detail
            : error.message));
            callBack(subscriptionConfig);
      });
  };
};

export const listActiveSubscriptions = (callBack: (users: UserData[]) => void) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get('/api/subscription/listactivesubscriptions') 
      .then((data) => {
        if (data.status === 200) {
          callBack(data.data);
        } else {
          dispatch(fetchError("Request failed. Status: " + data.status));
          callBack([]);
        }
      })
      .catch((error) => {
        dispatch(fetchError(
          error.response.data.detail
            ? error.response.data.detail
            : error.message));
            callBack([]);
      });
  };
};

export const getUserSubscription = (callback: (success: boolean, subscriptionData: SubscriptionData | null) => void) => {
  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get("/api/subscription/usersubscription")
      .then((response) => {
        if (response.status === 200) {
          const subscriptionData: SubscriptionData = response.data;

          subscriptionData.amount = subscriptionData.amount.slice(0, subscriptionData.amount.length-2) + '.' + subscriptionData.amount.slice(-2);
          subscriptionData.status = subscriptionData.status.charAt(0).toUpperCase() + subscriptionData.status.slice(1);

          callback(true, subscriptionData);
        } else {
          console.error(`Error fetching current subscription with status: ${response.status}`);
          callback(false, null);
        }
      })
      .catch((error) => {
        console.error('Error fetching current subscription:', error);
        callback(false, null);
      });
  };
};
